/**
 * Tab-local "session end in flight" latch — blocks concurrent revive / refresh
 * while clear-local-first logout runs.
 */

let sessionEndingLatch = false;

export function beginSessionEndingLatch(): void {
  sessionEndingLatch = true;
}

export function endSessionEndingLatch(): void {
  sessionEndingLatch = false;
}

export function isSessionEndingLatchActive(): boolean {
  return sessionEndingLatch;
}

/** Test-only reset. */
export function resetSessionEndingLatchForTests(): void {
  sessionEndingLatch = false;
}
